import React, { createContext, useState, useEffect } from "react";
import { supabase } from "../supabaseClient"; // Your initialized client

export const JobsContext = createContext();

export const JobsProvider = ({ children }) => {
  const [jobs, setJobs] = useState([]);

  useEffect(() => {
    const fetchJobs = async () => {
      const { data, error } = await supabase
        .from("jobs")
        .select()
        .eq("is_deleted", false);

      if (error) {
        console.error("Error fetching jobs:", error);
        return;
      }

      const jobsList = data.map((job) => {
        return {
          ...job,
          last_date: job.last_date
            ? new Date(job.last_date).toLocaleDateString()
            : null,
          start_date: job.start_date
            ? new Date(job.start_date).toLocaleDateString()
            : null,
        };
      });

      jobsList.sort((a, b) => new Date(b.created_at) - new Date(a.created_at));

      setJobs(jobsList);
    };

    fetchJobs();
  }, []);

  return (
    <JobsContext.Provider value={{ jobs }}>
      {children}
    </JobsContext.Provider>
  );
};